import React from "react";
import InternalForm from "../bodies/InternalForm";
import ResetPasswordForm from "../molecules/forms/ResetPasswordForm";
import SEO from "../molecules/hidden/SEO";

const ChangePassword = () => (
  <InternalForm>
    <SEO name="Change Password" />
    <ResetPasswordForm />
  </InternalForm>
);

export default ChangePassword;
